(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (el) { initCarousel(el); });

    function initCarousel(root) {
      var allSlides = root.querySelectorAll('[data-slide-index]');
      var allDots = root.querySelectorAll('[data-dot-index]');
      var cursor = root.querySelector('[data-cursor]');
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      /* Filter visible slides for current device */
      var slides = [];
      var dots = [];
      allSlides.forEach(function(s, i) {
        var hideDesktop = s.dataset.hideDesktop === 'true';
        var hideMobile = s.dataset.hideMobile === 'true';
        var visible = !((isMobile && hideMobile) || (!isMobile && hideDesktop));
        if (visible) {
          slides.push(s);
          if (allDots[i]) dots.push(allDots[i]);
        } else {
          if (allDots[i]) allDots[i].style.display = 'none';
        }
      });

      var count = slides.length;

      if (count < 2) return;

      /* Make sure first visible slide is active */
      allSlides.forEach(function(s) { s.classList.remove('hc__slide--active'); });
      allDots.forEach(function(d) { d.classList.remove('hc__dot--active'); });
      slides[0].classList.add('hc__slide--active');
      if (dots[0]) dots[0].classList.add('hc__dot--active');

      var autoplayEnabled = root.dataset.autoplay === 'true';
      var speed = (parseInt(root.dataset.autoplaySpeed, 10) || 5) * 1000;
      var current = 0;
      var autoplayTimer = null;
      var resumeTimer = null;
      var paused = false;
      var touchStartX = 0;
      var touchStartY = 0;
      var isTouch = 'ontouchstart' in window;

      root.style.setProperty('--hc-autoplay-speed', (speed / 1000) + 's');

      /* Dot style */
      var sectionId = root.closest('[data-section-id]');
      /* The dot style is handled via CSS class set by Liquid if needed */

      function goTo(index) {
        if (index === current) return;

        slides[current].classList.remove('hc__slide--active');
        dots[current] && dots[current].classList.remove('hc__dot--active');

        /* Reset old progress */
        var oldProg = dots[current] && dots[current].querySelector('[data-dot-progress]');
        if (oldProg) {
          oldProg.style.animation = 'none';
          oldProg.offsetHeight;
          oldProg.style.animation = '';
        }

        current = ((index % count) + count) % count;

        slides[current].classList.add('hc__slide--active');
        dots[current] && dots[current].classList.add('hc__dot--active');

        /* Restart progress animation on new active dot */
        var newProg = dots[current] && dots[current].querySelector('[data-dot-progress]');
        if (newProg) {
          newProg.style.animation = 'none';
          newProg.offsetHeight;
          newProg.style.animation = '';
        }
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      /* Autoplay */
      function startAutoplay() {
        if (!autoplayEnabled) return;
        stopAutoplay();
        paused = false;
        root.classList.remove('hc--paused');
        autoplayTimer = setInterval(next, speed);
      }

      function stopAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function pauseAutoplay() {
        if (!autoplayEnabled || paused) return;
        paused = true;
        root.classList.add('hc--paused');
        stopAutoplay();
        clearTimeout(resumeTimer);
      }

      function scheduleResume() {
        if (!autoplayEnabled) return;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          startAutoplay();
          /* Restart progress on current dot */
          var prog = dots[current] && dots[current].querySelector('[data-dot-progress]');
          if (prog) {
            prog.style.animation = 'none';
            prog.offsetHeight;
            prog.style.animation = '';
          }
        }, 3000);
      }

      /* Click navigation: left half = prev, right half = next */
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-dot-index]') || e.target.closest('.hc__cta') || e.target.closest('a')) return;

        var rect = root.getBoundingClientRect();
        var x = e.clientX - rect.left;
        if (x < rect.width / 2) {
          prev();
        } else {
          next();
        }
        pauseAutoplay();
        scheduleResume();
      });

      /* Dot clicks */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          goTo(parseInt(dot.dataset.dotIndex, 10));
          pauseAutoplay();
          scheduleResume();
        });
      });

      /* Custom cursor (desktop only) */
      if (!isTouch && cursor) {
        root.addEventListener('mouseenter', function () {
          cursor.classList.add('hc__cursor--visible');
        });

        root.addEventListener('mouseleave', function () {
          cursor.classList.remove('hc__cursor--visible');
          scheduleResume();
        });

        root.addEventListener('mousemove', function (e) {
          cursor.style.left = e.clientX + 'px';
          cursor.style.top = e.clientY + 'px';

          var rect = root.getBoundingClientRect();
          var x = e.clientX - rect.left;
          if (x < rect.width / 2) {
            cursor.classList.add('hc__cursor--left');
          } else {
            cursor.classList.remove('hc__cursor--left');
          }
        });

              /* Pause on hover */
        root.addEventListener('mouseenter', function () {
          pauseAutoplay();
        });

        root.addEventListener('mouseleave', function () {
          scheduleResume();
        });

        /* Nascondi la freccia (cursore custom) quando si è sopra il pulsante */
        root.querySelectorAll('.hc__cta').forEach(function (btn) {
          btn.addEventListener('mouseenter', function () { cursor.classList.remove('hc__cursor--visible'); });
          btn.addEventListener('mouseleave', function () { cursor.classList.add('hc__cursor--visible'); });
        });
      }


      /* Touch swipe */
      root.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
        pauseAutoplay();
      }, { passive: true });

      root.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;

        /* Only swipe if horizontal movement > vertical and > 50px threshold */
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
          if (dx < 0) { next(); } else { prev(); }
        }
        scheduleResume();
      }, { passive: true });

     /* Start */
      startAutoplay();
    }

    /* Force play all hero videos (overcome autoplay restrictions) */
    function forcePlayVideos() {
      document.querySelectorAll('.hc__video-el').forEach(function(v) {
        v.muted = true;
        v.defaultMuted = true;
        var p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function() {
            /* If still blocked, try again on first user interaction */
            var resume = function() {
              v.play().catch(function(){});
              document.removeEventListener('touchstart', resume);
              document.removeEventListener('click', resume);
              document.removeEventListener('scroll', resume);
            };
            document.addEventListener('touchstart', resume, { once: true, passive: true });
            document.addEventListener('click', resume, { once: true });
            document.addEventListener('scroll', resume, { once: true, passive: true });
          });
        }
      });
    }

    forcePlayVideos();
    /* Try again after a delay (some browsers need a second push) */
    setTimeout(forcePlayVideos, 500);
    setTimeout(forcePlayVideos, 1500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["persona-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-persona-tabs]').forEach(initPersonaTabs);
  });

  function initPersonaTabs(root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      var line = root.querySelector('[data-tab-line]');
      var current = parseInt(root.dataset.defaultTab, 10) || 0;

      /* ---- Tab indicator position ---- */
      function updateLine(tab) {
        if (!line || !tab) return;
        line.style.width = tab.offsetWidth + 'px';
        line.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      }

      /* ---- Switch tab ---- */
      function switchTo(index) {
        if (index === current) return;

        tabs[current].classList.remove('pt__tab--active');
        tabs[current].setAttribute('aria-selected', 'false');
        panels[current].classList.remove('pt__panel--active');

        current = index;

        tabs[current].classList.add('pt__tab--active');
        tabs[current].setAttribute('aria-selected', 'true');
        updateLine(tabs[current]);

        /* Crossfade: brief hidden state then fade in */
        var panel = panels[current];
        panel.style.opacity = '0';
        panel.classList.add('pt__panel--active');
        /* Force reflow then animate */
        panel.offsetHeight;
        panel.style.opacity = '';
      }

      /* Tab clicks */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          switchTo(parseInt(tab.dataset.tab, 10));
        });
      });

      /* Init indicator */
      if (tabs[current]) {
        /* Defer to ensure layout is complete */
        requestAnimationFrame(function () {
          updateLine(tabs[current]);
        });
      }

      /* Recalc on resize */
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateLine(tabs[current]);
        }, 100);
      });

      /* ---- Carousel arrows ---- */
      root.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
        var track = wrap.querySelector('[data-carousel-track]');
        var section = wrap.closest('.pt__section');
        var prev = section ? section.querySelector('[data-carousel-prev]') : null;
        var next = section ? section.querySelector('[data-carousel-next]') : null;
        if (!track) return;

        function getScrollAmount() {
          var card = track.querySelector('.pt__carousel-item');
          if (!card) return 300;
          var style = getComputedStyle(track);
          var gap = parseFloat(style.gap) || 16;
          return card.offsetWidth + gap;
        }

        if (prev) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
          });
        }

        var progressFill = wrap.querySelector('[data-carousel-progress-fill]');
        if (progressFill) {
          var updateProgress = function () {
            var maxScroll = track.scrollWidth - track.clientWidth;
            var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
            progressFill.style.width = pct + '%';
          };
          track.addEventListener('scroll', updateProgress);
          updateProgress();
        }
      });

    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prodottoraccomandato"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-recs]').forEach(function (el) {
      window.initProductRecs(el);
    });
  });

  window.initProductRecs = function (root) {
    root.querySelectorAll('[data-carousel-wrap]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-carousel-track]');
      var section = wrap.closest('.prec__section');
      var prev = section ? section.querySelector('[data-carousel-prev]') : null;
      var next = section ? section.querySelector('[data-carousel-next]') : null;
      if (!track) return;

      function getScrollAmount() {
        var card = track.querySelector('.prec__carousel-item');
        if (!card) return 300;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 16;
        return card.offsetWidth + gap;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      var progressFill = wrap.querySelector('[data-carousel-progress-fill]');
      if (progressFill) {
        var updateProgress = function () {
          var maxScroll = track.scrollWidth - track.clientWidth;
          var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;
          progressFill.style.width = pct + '%';
        };
        track.addEventListener('scroll', updateProgress);
        updateProgress();
      }
    });
  };

  } catch(e) { console.error(e); }
})();
})();
